import { useEffect, useRef, useState } from 'react';
import { previewNewsAsHTML } from '../../../misc/lib/news';
import './UploadNewsPage.scss';

const NewsBodyEditor = (props: {
  text: string;
  onTextChanged: (text: string) => void;
}) => {
  const [ previewActive, setPreviewActive ] = useState(false);
  const previewRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!!previewRef.current) {
      previewRef.current.innerHTML = previewNewsAsHTML(props.text);
    }
  }, [ props.text, previewActive ]);

  return (
    <div className="uploadnewspage-body-editor-container">
      { previewActive ? (
        <div className="preview" ref={ previewRef }></div>
      ) : (
        <textarea className="editor"
          value={ props.text } onChange={ (event) => {
            props.onTextChanged(event.currentTarget.value);
          } } spellCheck="true" wrap="soft" placeholder="Aa..">
        </textarea>
      ) }
      <button className={ previewActive ? 'preview-active' : undefined }
        onClick={ () => setPreviewActive(!previewActive) }>
        Előnézet
      </button>
    </div>
  );
};

export default NewsBodyEditor;
